import type { ChecklistItem } from '../types/schema'

type ChecklistScheduleFields = Pick<ChecklistItem,
  'scheduleStartDate' | 'scheduleEndDate' | 'startDate' | 'endDate'
>

export type ChecklistScheduleSpan = {
  startDate: string
  endDate: string
}

const toIsoDay = (value: string | null | undefined): string | null => {
  if (typeof value !== 'string') return null
  const day = value.slice(0, 10)
  return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : null
}

/**
 * Returns the canonical inclusive day span for a checklist. New schedule
 * fields win over legacy start/end fields independently, so a stale legacy
 * projection can never collapse a current duration back to one day.
 */
export const getChecklistScheduleSpan = (item: ChecklistScheduleFields): ChecklistScheduleSpan | null => {
  const startDate = toIsoDay(item.scheduleStartDate) ?? toIsoDay(item.startDate)
  const endDate = toIsoDay(item.scheduleEndDate) ?? toIsoDay(item.endDate) ?? startDate
  return startDate && endDate ? { startDate, endDate } : null
}

/** A real, non-degenerate span is duration regardless of a stale DATED flag. */
export const isDurationChecklist = (item: ChecklistScheduleFields): boolean => {
  const span = getChecklistScheduleSpan(item)
  return Boolean(span && span.startDate !== span.endDate)
}
